import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, RefreshCw } from 'lucide-react';
interface BlueRate {
  compra: number;
  venta: number;
  fechaActualizacion: string;
}
export function DollarTicker() {
  const [rate, setRate] = useState<BlueRate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const fetchRate = async () => {
    try {
      setError(false);
      const res = await fetch('https://dolarapi.com/v1/dolares/blue');
      if (!res.ok) throw new Error('bad response');
      const data = await res.json();
      setRate({
        compra: data.compra,
        venta: data.venta,
        fechaActualizacion: data.fechaActualizacion
      });
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRate();
    const interval = setInterval(fetchRate, 60000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (iso: string) => {
    try {
      return new Date(iso).toLocaleTimeString('es-AR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '—';
    }
  };
  const formatMoney = (n: number) => n.toLocaleString('es-AR', {
    minimumFractionDigits: 0
  });
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.3
  }} className="bg-white border border-slate-200 rounded-2xl p-5 shadow-lg max-w-sm w-full" data-id="element-13">
      <div className="flex items-center justify-between mb-4" data-id="element-14">
        <div className="flex items-center gap-2" data-id="element-15">
          <div className="relative flex h-2.5 w-2.5" data-id="element-16">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-17"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-18"></span>
          </div>
          <span className="text-sm font-bold text-[#0a2540] uppercase tracking-wide" data-id="element-19">
            Dólar Blue · En vivo
          </span>
        </div>
        <TrendingUp className="w-4 h-4 text-blue-700" data-id="element-20" />
      </div>

      {loading ? <div className="flex items-center justify-center py-6 text-slate-400 gap-2" data-id="element-21">
          <RefreshCw className="w-4 h-4 animate-spin" data-id="element-22" />
          <span className="text-sm" data-id="element-23">Cargando cotización…</span>
        </div> : error ? <div className="py-4 text-center" data-id="element-24">
          <p className="text-sm text-slate-500 mb-2" data-id="element-25">
            No pudimos cargar la cotización.
          </p>
          <button onClick={fetchRate} className="text-sm font-semibold text-blue-700 hover:text-blue-800" data-id="element-26">
            Reintentar
          </button>
        </div> : rate && <>
            <div className="grid grid-cols-2 gap-3" data-id="element-27">
              <div className="bg-slate-50 border border-slate-100 rounded-xl p-4 text-center" data-id="element-28">
                <p className="text-xs font-medium text-slate-500 uppercase mb-1" data-id="element-29">
                  Compra
                </p>
                <p className="text-2xl font-extrabold text-[#0a2540]" data-id="element-30">
                  ${formatMoney(rate.compra)}
                </p>
              </div>
              <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-center" data-id="element-31">
                <p className="text-xs font-medium text-blue-600 uppercase mb-1" data-id="element-32">
                  Venta
                </p>
                <p className="text-2xl font-extrabold text-blue-700" data-id="element-33">
                  ${formatMoney(rate.venta)}
                </p>
              </div>
            </div>
            <p className="text-[11px] text-slate-400 text-center mt-3" data-id="element-34">
              Actualizado {formatTime(rate.fechaActualizacion)} hs · Fuente:
              mercado informal
            </p>
          </>}
    </motion.div>;
}